export const getErrorMessage = (requestError, errorTranslations) => {
  let errors = {};
  let errorDetails = requestError.details || {};

  switch (Array.isArray(errorDetails) ? errorDetails[0].type : errorDetails.type) {
    case 'any.empty':
      errors.email = errorTranslations.general.required || errorDetails[0].message;
      break;
    case 'string.email':
      errors.email = errorTranslations.general.invalid || errorDetails[0].message;
      break;
    default:
      errors.email = errorTranslations.generalError || errorDetails;
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/client/js/view/components/SaveForLater/helpers.js